import React from 'react';

const SvgGr = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="GR_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="GR_svg__b" fill="#fff">
        <use xlinkHref="#GR_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        d="M13.333 13.333H8V8h5.333v2.667H28v2.666H13.333zm0-13.333H28v2.667H13.333v2.666H8V0h5.333zM0 0h5.333v5.333H0V0zm13.333 5.333H28V8H13.333V5.333zM0 16h28v2.667H0V16zm0-8h5.333v5.333H0V8z"
        fill="#1C6DC1"
        mask="url(#GR_svg__b)"
      />
    </g>
  </svg>
);

export default SvgGr;
